import React, { useContext } from 'react';

import DocumentsContainer from '@totem/components/documents/report/documentsContainer';
import DocumentsContext from '@totem/components/documents/report/documentsContext';
import DocumentsTable from '@totem/components/documents/report/documentsTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const SalesOrderDocumentsCard = () => {
  const { totalRecords } = useContext(DocumentsContext);

  return (
    <IBCard
      title="Documents"
      extra={<RecordCountBadge count={totalRecords} />}
      style={{ marginBottom: 16 }}
    >
      <DocumentsTable />
    </IBCard>
  );
};

type Props = {
  salesOrderNumber: string;
};

// Matches on the reference name (transaction ID) rather than the reference ID: older
// documents reference the legacy contract record while newer ones use the NetSuite ID.
const SalesOrderDocumentsPanel = ({ salesOrderNumber }: Props) => {
  return (
    <DocumentsContainer
      staticFilters={{
        referencedItemType: 'Sales Order',
        referencedItemNames: [salesOrderNumber],
      }}
    >
      <SalesOrderDocumentsCard />
    </DocumentsContainer>
  );
};

export default SalesOrderDocumentsPanel;
